import whyDidYouRender from "@welldone-software/why-did-you-render";
import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { Redirect, Route, Switch, useLanguage } from "@ipc/ipc-core";
import { AppContainerStyle } from "./AppContainer.styles";
import AppHeader from "./header/AppHeader";
import Login from "./Login";
import AppContent from "./AppContent";
import AppFooter from "./AppFooter";
import LoginFailPage from "./LoginFailed";
import { httpOnlySecurityService } from "../../externals/iam";

if (process.env.NODE_ENV !== "production") {
  whyDidYouRender(React);
}

const StyledAppContainer = styled.div`
  ${AppContainerStyle}
`;
StyledAppContainer.displayName = "StyledAppContainer";

const GlobalStyle = createGlobalStyle`
  #root, body, html {
    margin:0; padding: 0;
    height: 100%;
  }
`;

const PrivateArea = () => {
  const pageClassName = window.location.href;
  const substr = pageClassName
    .replace(/^.*en/, "")
    .substring(1)
    .replace(/\//g, "-")
    .toLocaleLowerCase();

  return (
    <div className={`${substr} main-container`}>
      <div className="page-wrapper">
        <AppHeader />
        <AppContent />
        <AppFooter />
      </div>
    </div>
  );
};

export const PublicArea = () => {
  const [, language] = useLanguage();
  const pageClassName = window.location.href;
  const substr = pageClassName
    .replace(/^.*en/, "")
    .substring(1)
    .replace(/\//g, "-")
    .toLocaleLowerCase();

  return (
    <div className={`${substr} main-container`}>
      <div className="page-wrapper">
        <AppHeader />
        <Switch>
          <Route>
            <Route
              exact
              path="/"
              render={() => <Redirect to={language("/login")} />}
            />
            <Switch>
              <Route exact path={language("/login")} component={Login} />
              <Route
                exact
                path={language("/login-failed")}
                component={LoginFailPage}
              />
              <Route render={() => <Redirect to={language("/login")} />} />
            </Switch>
          </Route>
        </Switch>
        <AppFooter />
      </div>
    </div>
  );
};

export const AppContainerComponent = () => {
  return (
    <>
      <GlobalStyle />
      <StyledAppContainer>
        {httpOnlySecurityService.isUserAuthenticated() ? (
          <PrivateArea />
        ) : (
          <PublicArea />
        )}
      </StyledAppContainer>
    </>
  );
};

export default AppContainerComponent;
